import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { ThemeProvider } from "./theme/ThemeProvider.js";
import { App } from "./App.js";
import "./styles/tokens.css";
import "./styles/base.css";
import "./styles/app.css";
import "./styles/kit.css";
import "./styles/console.css";

const rootEl = document.getElementById("root");
if (!rootEl) throw new Error("#root not found");

createRoot(rootEl).render(
  <StrictMode>
    <ThemeProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </ThemeProvider>
  </StrictMode>,
);

// BOOT LOADER removal (embed-boot-loader): index.html's inline `#td-boot-loader` spinner paints
// before this bundle even downloads (that's its whole job — see index.html's comment). Once React
// has rendered its first commit, the real app shell (TownHeader, the route's own skeleton/spinner,
// etc.) is on screen, so the boot loader's job is done — remove it here rather than leaving it to
// fade out or rely on z-index, so it can never linger over real content. `createRoot(...).render`
// schedules work; a microtask-deferred removal (rather than removing synchronously right after the
// call) ensures React has actually committed the first paint before we pull the loader, so there's
// no one-frame gap where neither is visible.
queueMicrotask(() => {
  document.getElementById("td-boot-loader")?.remove();
});
